module.exports = __webpack_public_path__ + "img/error.75eeaf06.svg";